import React, { Component } from "react";
import { Button, Form, Image } from "react-bootstrap";
import { ERROR_MSG, DOCUMENT_FORMATS } from "../../constant";
import { Field } from "../../component";
import { get } from "lodash";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { modifyDataForDuplicate } from "./helper";
import { UploadAttachmentsWithTitleComponent } from "../reusableComponent/uploadAttchements";
//import { DisplayAttachments } from "../reusableComponent/displayAttachments";
import { DisplayAttachments } from "../reusableComponent/displayAttachments/indexForward";
import IconPin from "../../assets/icon-pin.png";
import Forma from "../../assets/Forma 1.svg";
import { markAsDuplicate } from "../../actions/issues.action";
import { handleLanguage, handlePaste } from "../../helper";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import { successToastStyle, errorToastStyle } from "../../customToast";
import { ConfirmationComponent } from "../ConfirmationComponent";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";
class MarkAsDuplicate extends Component {
  state = {
    template: [],
    files: [],
    error: {},
    languageError: null,
    pasteError: false,
    pastedText: "",
    comment: "",
    showCommentPopUp: false,
    isHindi: false
  };

  onChange = (value, key) => {
    const { options } = this.props;
    const data = { [key]: value };
    if (key === "to") {
      const find = options.find(key => key.id === +value);
      data["originalId"] = find && find.id;
    }
    if (key === "to") {
      const testHindi = options.some(
        val => typeof val.name === "string" && /[\u0900-\u097F]/.test(val.name)
      );
      testHindi
        ? this.setState({ isHindi: true })
        : this.setState({ isHindi: false });
    }
    this.setState({ ...data }, () => {
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
  };

  onCloseModal = e => {
    this.setState({ showCommentPopUp: false });
  };
  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  returnUploadedImageList = template => {
    this.setState({
      template: template
    });
  };
  onBlur = value => {};
  onSend = () => {
    const { to, error, comment } = this.state;
    if (
      !error.to ||
      get(error, "to.error") ||
      ((comment === undefined || !comment.trim()) &&
        (!error.comment || get(error, "comment.error")))
    ) {
      this.setState({
        languageError: false,
        pasteError: false,
        error: {
          to: {
            error: !to,
            message: !to && ERROR_MSG.DEFAULT_MSG
          },
          comment: {
            error: comment === undefined || !comment.trim(),
            message:
              (comment === undefined || !comment.trim()) &&
              ERROR_MSG.DEFAULT_MSG
          }
        }
      });
    } else {
      this.setState(prevState => ({
        sendTo: !prevState.sendTo,
        showCommentPopUp: true
      }));
    }
  };

  onDelete = e => {
    // if(this.props.markduplicatebtn){
    //   this.props.onCloseButton("1")
    // }
    // else{
    //   this.props.markDuplicateBTN("0")
    // }
    this.props.onCloseButton("1");
    this.props.markDuplicateBTN("0");
    const { resetAction } = this.props;
    resetAction(e);
  };

  onGetFilesData = files => {
    this.setState({
      files
    });
  };

  onSubmit = async e => {
    this.setState({ showCommentPopUp: false });
    const { files, comment, originalId } = this.state;
    const {
      markAsDuplicate,
      issueDetails: { id },
      callApiOnSuccess
    } = this.props;
    const data = modifyDataForDuplicate({ files, id, comment, originalId });
    const resp = await markAsDuplicate(data);
    if (resp) {
      const { status, message } = resp;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      status && callApiOnSuccess(e);
    }
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      console.error(error.message);
    }
  };

  // uploded comes tru in case of file
  // is uploaded
  onToggleAttachment = index => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };
  inputLanguage = event => {
    const { issueDetails } = this.props;
    const project = get(issueDetails, "project");
    if (window.event.inputType !== "insertFromPaste") {
      if (
        !event.target.value.match(/[\u0900-\u097F]/) ||
        get(project, "sponsoredByCategory") != "STATE"
      ) {
        let hasInputValue = handleLanguage(event);
        this.setState({
          languageError: hasInputValue,
          pasteError: false,
          comment: event.target.value
        });
      }
    }
  };

  pasteLanguage = () => {
    const { issueDetails } = this.props;
    const project = get(issueDetails, "project");
    if (
      !this.state.comment.match(/[\u0900-\u097F]/) ||
      get(project, "sponsoredByCategory") != "STATE"
    ) {
      let { filterString, hasBadValue } = handlePaste(this.state.comment);
      if (hasBadValue === true) {
        this.setState({
          pasteError: hasBadValue,
          comment: filterString
        });
      }
    }
  };

  render() {
    const {
      sendTo,
      error,
      files,
      toggleAttachementDisplay,
      pasteError,
      languageError,
      comment,
      showCommentPopUp
    } = this.state;
    const { options } = this.props;
    // let attachmentTitle;
    // if (files.length > 0) {
    //   let extension = files[0].name.substr(
    //     files[0].name.lastIndexOf(".") + 1,
    //     files[0].name.length
    //   );
    //   let omTitle = files[0].title;
    //   let omName = files[0].name;
    //   if (omTitle !== null) {
    //     attachmentTitle =
    //       omTitle.length > 20 ? omTitle.substring(0, 20) + "..." : omTitle;
    //   } else {
    //     attachmentTitle =
    //       omName.length > 20 ? omName.substring(0, 20) + "..." : omName;
    //   }
    //   files[0].title = attachmentTitle;
    // }
    return (
      <div className="forward-to-team">
        {toggleAttachementDisplay ? (
          <UploadAttachmentsWithTitleComponent
            displayModal={toggleAttachementDisplay}
            onCloseModal={this.onToggleAttachment}
            fileFormats={DOCUMENT_FORMATS}
            onSubmit={this.onSuccessUploadOfAttachmets}
          />
        ) : null}
        <div
          // style={{
          //   background: "#F5F5F5",
          //   border: "1px solid #ced7f4",
          //   height: "35px"
          // }}
          className="forward-to-team-main-div"
          style={{
            marginTop: window.location.pathname == "/issue-detail" ? "12px" : ""
          }}
        >
          <h3 className="heading">Mark Duplicate</h3>
          <div
            //className="btn-icon remove-issue-fwd"
            className="delete-padding"
            title="Delete"
            onClick={this.onDelete}
            // style={{
            //   position: "relative",
            //   left: "95%",
            //   bottom: "33px",
            //   width: "17px"
            // }}
          >
            <Image src={Forma} alt="Delet Icon" />
          </div>
        </div>
        <Form
          className={`forward-to-team-form ${
            languageError === true || (pasteError === true && comment !== "")
              ? "language-error-border-alert"
              : (get(error, "to.error") || get(error, "comment.error")) &&
                "error-field"
          }`}
        >
          <div className={"forward-to-team-form-content"}>
            <Form.Group className="field-select field-to">
              <Form.Label className={"mark-as-duplicate-label"}>
                Original Issue Id
              </Form.Label>
              {/* <CustomDropdown
                options={[
                  { value: "", label: "- Select -" },
                  ...options.map(item => ({
                    value: item.id,
                    label: `#${item.id} | ${item.name}`
                  }))
                ]}
                // value={options.find(o => o.value === this.state.to || "")}
                onChange={this.onChange}
                width={"100%"}
                height={"43px"}
                className={`issue-action custom-dropdown mark-as-duplicate-dropdown 
                ${this.state.isHindi ? "hindi-text-wrap hindi-dropdown" : ""}`}
                page={"mark-duplicate-select-issue"}
                menuClassName={"markDuplicateSelectIssueMenu"}
                marginRight={"10px"}
              /> */}
              <Field
                as="select"
                keyName="to"
                className={`${this.state.isHindi ? "hindi-text-wrap" : ""}`}
                style={{
                  fontFamily: this.state.isHindi
                    ? '"Mukta", sans-serif'
                    : "mpsb",
                  fontWeight: this.state.isHindi ? 600 : "",
                  letterSpacing: this.state.isHindi ? "0.5px" : ""
                }}
                onChange={this.onChange}
                onError={this.onError}
                isInvalid={get(error, "to.error")}
                onBlur={this.onBlur}
              >
                <option value="">- Select -</option>
                {(options || []).map(value => {
                  return (
                    <option
                      value={value && value.id}
                      className={`${
                        value.name.match(/[\u0900-\u097F]/)
                          ? "hindi-text-wrap"
                          : ""
                      }`}
                      style={{
                        fontFamily: value.name.match(/[\u0900-\u097F]/)
                          ? '"Mukta", sans-serif'
                          : "mpsb"
                      }}
                    >
                      #{value && value.id} | {value && value.name}
                    </option>
                  );
                })}
              </Field>
            </Form.Group>
            <Form.Group
              className={files.length !== 0 ? "text-area" : "text-area1"}
            >
              {/* <Field
                as="textarea"
                rows="4"
                keyName="comment"
                value={comment}
                onChange={this.onChange}
                onError={this.onError}
                onInput={this.inputLanguage}
                placeholder="Add Description"
                isInvalid={get(error, "comment.error")}
              />
              {this.state.comment !== null &&
                this.state.comment !== undefined &&
                this.state.comment.length === 0 && (
                  <span
                    className="required"
                    style={{
                      position: "absolute",
                      left: "17.8%",
                      paddingTop: "6px"
                    }}
                  >
                    *
                  </span>
                )} */}
              <Field
                as="textarea"
                rows="4"
                keyName="comment"
                onChange={this.onChange}
                onError={this.onError}
                //placeholder="Description"
                isInvalid={get(error, "comment.error")}
                value={comment}
                onInput={this.inputLanguage}
                onBlur={this.onBlur}
              />
              {this.state.comment == "" ? (
                <>
                  <label
                    for="some-id"
                    class="textfield-fwd__label textfield-fwd__label--required"
                  >
                    Add Description
                  </label>
                </>
              ) : (
                <></>
              )}
            </Form.Group>
            {files.length !== 0 ? (
              <hr style={{ marginTop: "8px", marginBottom: "0px" }} />
            ) : null}
            <Form.Group className="field-attachment">
              <DisplayAttachments
                filesArr={files}
                onRemoveFile={this.onRemoveFile}
                addAttchementRequired={false}
                classes="attachments"
              />
            </Form.Group>
          </div>
          {/* <div className="forward-to-team-footer">
            <div className="forward-to-team-buttons">
              <Button className="btn-orange no-padding" onClick={this.onSend}>
                Send
              </Button>
              <div className="add-attachment" onClick={this.onToggleAttachment}>
                <div className="add-attachment-button">
                  <Image src={IconPin} alt="Attachment Icon" />
                  Add Attachment
                </div>
              </div>
              <div
                className="btn-icon remove-issue"
                title="Delete"
                onClick={this.onDelete}
              />
            </div>
          </div> */}
          <div className="forward-to-team-footer">
            <div className="forward-to-team-buttons">
              <div className="add-attachment" onClick={this.onToggleAttachment}>
                <div className="add-attachment-button" colSpan={6}>
                  <Image src={IconPin} alt="Attachment Icon" />
                  Add Attachment
                </div>
              </div>
              <div
                //style={{ position: "relative", left: "69%", bottom: "-5px" }}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  position: "relative"
                }}
              >
                <Button
                  className="btn-orange no-padding-send"
                  onClick={this.onSend}
                  style={{ marginTop: "10px" }}
                >
                  SUBMIT
                </Button>
              </div>
            </div>
          </div>
        </Form>
        {languageError === true || pasteError === true ? (
          <div className="warning">
            <Image src={CircleWithExclamation} />
            Only English language is supported.
          </div>
        ) : (
          <></>
        )}
        {((get(error, "to.error") || get(error, "comment.error")) && (
          <span className="invalid-feedback">Mandatory fields are missing</span>
        )) ||
          null}
        {(showCommentPopUp && (
          <ConfirmationComponent
            show={showCommentPopUp}
            isLoading={false}
            modalClass={"confirmation-modal"}
            saveHandler={this.onSubmit}
            closeHandler={this.onCloseModal}
            content={
              " Duplicate issue will be rejected. Are you sure you want to mark this issue duplicate ?"
            }
          />
          // <div className="forward-to-team-confirmation">
          //   <div className="confirmation-inner">
          //     Duplicate issue will be rejected. Are you sure you want to mark
          //     this issue duplicate ?
          //     <div className="confirmation-buttons">
          //       <Button className="btn-orange" onClick={this.onSubmit}>
          //         Yes
          //       </Button>
          //       <Button className="btn-orange-invert" onClick={this.onSend}>
          //         No
          //       </Button>
          //     </div>
          //   </div>
          // </div>
        )) ||
          null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      markAsDuplicate
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarkAsDuplicate);
